module.exports = __webpack_public_path__ + "static/media/a13.2e96e023.pdf";